/**
 * Generate an array of specified length with items corresponding to their index.
 * Often used to generate an aribitrary number of React elements.
 */
export const arrayOf = (length: number) => {
  return [...new Array(length)].map((_, i) => i);
};
